import React from 'react';

import PropTypes from 'prop-types';

export default function EmptyTableState({ children, icon, title }) {
  const Icon = icon;

  return (
    <div className='tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-3 tw-py-20'>
      <Icon className='tw-h-12 tw-w-12 [&_path]:tw-fill-grey-300' />
      <p className='tw-mb-0 tw-text-l tw-font-semibold tw-text-grey-900'>
        {title}
      </p>
      {children}
    </div>
  );
}

EmptyTableState.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
};
